module.exports = __webpack_public_path__ + "img/slider_4.704b2d50.jpg";